<template>
  <div class="test-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>社区管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div>
        <el-cascader v-model="selectedOptions" :options="options" placeholder="请选择省市区" class="dropdown" :props="{
          value: 'label',
          label: 'label',
        }"></el-cascader>
      </div>
      <div>
        <el-button type="primary" size="small" @click.native="Query">查询</el-button>
      </div>
      <div class="add">
        <el-button type="primary" size="small" @click="goTo('/community-add')">+ 添加社区</el-button>
      </div>
    </div>
    <div class="list">
      <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName" size="small">
        <el-table-column prop="community" label="社区管理"> </el-table-column>
        <el-table-column label="显示的图片">
          <template slot-scope="scope">
            <img v-if="scope.row.qrcode" :src="scope.row.qrcode" class="table-image" alt="Uploaded Image" />
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="c_time"-->
        <!--          label="添加时间">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--          prop="id"-->
        <!--          label="问卷记录">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button type="success"  size="small"  @click.native="exportData(scope.row.title,scope.row.id)">导出记录</el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column prop="id" label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="primary" size="small" @click="goTo('/community-edit', scope.row.id)">编辑</el-button> -->
            <!-- <el-button type="danger" size="small" @click="deleteTest(scope.row.id)">删除</el-button> -->
            <el-button type="primary" size="small" @click="goToBEnd(scope.row.id)">跳转详细信息</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
        :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>


<script>
import {
  regionData,
  codeToText,
  provinceAndCityData,
} from "element-china-area-data";

export default {
  data() {
    return {
      pages: 1,
      limit: 10,
      province: "北京市",
      city: "市辖区",
      district: "朝阳区",

      options: [
        {
          label: "北京市",
          children: [
            {
              label: "市辖区",
              children: [
                {
                  label: "东城区",
                },
                {
                  label: "西城区",
                },
                // 其他区县...
              ],
            },
            // 其他城区...
          ],
        },
        // 其他省份...
      ],
      selectedOptions: [],
      defaultSelectedOptions: [],
      key: "",
      tableData: [],
      total: 0,
      export_test_title: "",
      export_test_id: "",
      centerDialogVisible: false,
      time_slot: ["", ""],
      districts: [
        {
          label: "省份1",
          children: [
            {
              label: "市1",
              children: [
                {
                  label: "区1",
                  areas: [
                    { name: "街道1", value: 100 },
                    { name: "街道2", value: 200 },
                    { name: "街道3", value: 150 },
                  ],
                },
                // 其他区的数据...
              ],
            },
            {
              label: "市2",
              children: [
                {
                  label: "区3",
                  areas: [
                    { name: "街道1", value: 2 },
                    { name: "街道2", value: 200 },
                    { name: "街道3", value: 150 },
                  ],
                },
                {
                  label: "区4",
                  areas: [
                    { name: "街道5", value: 2 },
                    { name: "街道5", value: 80 },
                    { name: "街道3", value: 150 },
                  ],
                },
                // 其他区的数据...
              ],
            },
            // 其他市的数据...
          ],
        },
        {
          label: "省份2",
          children: [
            {
              label: "市2",
              children: [
                {
                  label: "区2",
                  areas: [
                    { name: "街道2", value: 100 },
                    { name: "街道2", value: 200 },
                    { name: "街道2", value: 200 },
                    { name: "街道2", value: 200 },

                    { name: "街道2", value: 150 },
                  ],
                },
                // 其他区的数据...
              ],
            },
            // 其他市的数据...
          ],
        },
      ], // 区的选项数据
    };
  },
  methods: {
    getList2222() {
      console.log(this.pages, 'this.pages');
      console.log(this.limit, 'this.limit');
      this.$get(
        "/v1/admin/community?&pages=" +
        this.pages +
        "&limit=" +
        this.limit +
        "&province=" +
        this.province +
        "&city=" +
        this.city +
        "&district=" +
        this.district +
        "&community_head=" +
        1,
        {}
      ).then((res) => {
        console.log(res, 'res收拾收拾')
        if (res.status === 200) {
          console.log(res.data);
          this.options = res.data.options;

          this.selectedOptions = [
            this.options[0].label,
            this.options[0].children[0].label,
            this.options[0].children[0].children[0].label,
          ];
          this.province = this.options[0].label;
          this.city = this.options[0].children[0].label;
          this.district = this.options[0].children[0].children[0].label;
          this.defaultSelectedOptions = [
            this.options[0].label,
            this.options[0].children[0].label,
            this.options[0].children[0].children[0].label,
          ];

          this.getList();
        } else {
          this.$msg(res.data.msg);
        }
      });
    },
    getList() {
      this.$get(
        "/v1/admin/community?&pages=" +
        this.pages +
        "&limit=" +
        this.limit +
        "&province=" +
        this.province +
        "&city=" +
        this.city +
        "&district=" +
        this.district,
        {}
      ).then((res) => {
        console.log('res试试少时诵诗书', res)
        if (res.data.status === "success") {
          this.tableData = res.data.data.data;

          this.total = res.data.data.total;
        } else {
          this.$msg(res.data.msg);
        }
      });
    },

    Query() {
      this.pages = 1;
      console.log(this.selectedOptions);

      this.province = this.selectedOptions[0];
      this.city = this.selectedOptions[1];
      this.district = this.selectedOptions[2];
      this.getList();
    },
    // deleteTest(id){
    //   this.$confirm('确定删除当前问卷？', () => {
    //     this.$delete('/v1/admin/questionnaire', {id: id})
    //       .then((res) => {
    //         if (res.data.status === 'success') {
    //           this.getList();
    //         } else {
    //           this.$msg(res.data.msg)
    //         }
    //       });
    //   })
    // },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "";
      } else {
        return "success-row";
      }
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getList();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pages = val;
      this.getList();
      console.log(`当前页: ${val}`);
    },
    exportData(title, id) {
      this.export_test_title = title;
      this.export_test_id = id;
      this.centerDialogVisible = true;
    },
    exportConfirm() {
      this.time_slot = !this.time_slot ? ["", ""] : this.time_slot;
      this.$getFile(
        "/v1/admin/answer-record/XL?id=" +
        this.export_test_id +
        "&start_time=" +
        this.time_slot[0] +
        "&end_time=" +
        this.time_slot[1],
        {}
      ).then((res) => {
        if (res.status === 200) {
          this.downloadFile(res.data);
          this.centerDialogVisible = false;
        } else {
          this.$msg(res.statusText);
        }
      });
    },
    // downloadFile(file){
    //   const blob = new Blob([file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' }) // 构造一个blob对象来处理数据，并设置文件类型
    //   if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
    //     navigator.msSaveBlob(blob, this.filename)
    //   } else {
    //     const href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
    //     const a = document.createElement('a') //创建a标签
    //     a.style.display = 'none'
    //     a.href = href // 指定下载链接
    //     a.download = this.export_test_title + '答题详情.xlsx' //指定下载文件名
    //     a.click() //触发下载
    //     URL.revokeObjectURL(a.href) //释放URL对象
    //   }
    // },
    goTo(path, id) {
      this.$router.push({
        path: path,
        query: {
          id: id,
        },
      });
    },
    goToBEnd(id) {
      console.log(id, '======');
      this.$router.push({
        path: '/BEnd',
        query: {
          community_id: id,
        }
      });
    },
  },
  created() {
    this.getList2222();
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
/* .test-list */
/* .el-table .warning-row { */
/* background: oldlace; */
/* } */
.el-table .success-row {
  background: #f0f9eb;
}
.table-image {
  width: 100px;
  height: 100px;
}
.search {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
}

.el-cascader {
  margin-right: 30px;
}

.add {
  padding-left: 100px;
}

.list {
  min-height: 550px;
  border: 1px solid #EBEEF5;
}

.edit_icon {
  width: 20px;
  height: 20px;
  margin-left: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.el-input__inner {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/CommunityManagement/CommunityManagement.vue